export type SeoMeta = {
  title: string;
  description: string;
  keywords?: string;
  developer?: string;
  robots?: string;
  googlebot?: string;
};

const defaultSeo: SeoMeta = {
  title: "Arihant Infracon | Crafting World-Class Aviation Experiences",
  description:
    "Arihant Infracon is a leading aviation civil construction company in India, specializing in civil infrastructure, luxury retail, and airport maintenance projects. With over 40 years of experience, we are committed to delivering quality construction and building futures.",
  keywords:
    "Arihant Infracon, construction, quality construction, Delhi, Mumbai, building futures, real estate, infrastructure, construction company",
};

const seoByPath: Record<string, SeoMeta> = {
  "/": defaultSeo,
  "/about": {
    title: "About Us | Arihant Infracon - 40 Years of Excellence",
    description:
      "From foundations to finish, discover the legacy of Arihant Infracon in aviation and luxury infrastructure since 1985.",
  },
  "/contact": {
    title: "Contact Us | Arihant Infracon - Start Your Project",
    description:
      "Inquire for civil infrastructure, luxury retail, or airport maintenance projects. Offices in Delhi and Mumbai.",
  },
  "/projects": {
    title: "Projects | Arihant Infracon - Signature Works",
    description:
      "Explore Arihant Infracon's interior finishing and airside project portfolio across CSMIA, IGI, Jaipur, and Lucknow airports.",
  },
  "/environment-policy": {
    title: "Environment Policy | Arihant Infracon",
    description:
      "Environmental policy covering compliance, pollution prevention, resource efficiency, and ISO 14001:2015 alignment.",
  },
  "/hse-policy": {
    title: "HSE Policy | Arihant Infracon",
    description:
      "Health, Safety & Environment policy aligned with ISO 45001:2018, outlining risk controls, training, and incident reporting.",
  },
  "/quality-policy": {
    title: "Quality Policy | Arihant Infracon",
    description:
      "Quality policy aligned with ISO 9001:2015, covering objectives, QA/QC processes, and continual improvement.",
  },
};

const normalizePath = (pathname: string) => {
  if (!pathname || pathname === "/") return "/";
  return pathname.endsWith("/") ? pathname.slice(0, -1) : pathname;
};

export const getSeoForPath = (pathname: string) => {
  const normalized = normalizePath(pathname);
  const match = seoByPath[normalized];
  return match ? { ...defaultSeo, ...match } : defaultSeo;
};
